import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * Upload Image API call using Axios
 * @returns - Get Doc type and return the array of doc type
 */

export const GetDocTypeAPI = async () => {
  try {
    const response = await axios.get(`${getUrl(ApiType.DOC_TYPE)}`);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.docTypeAPIError, { badRequestOrder: "errorsFirst" });
  }
};
